import React, { forwardRef } from "react";

import { LearnerProps } from "./types";

const Learner = forwardRef<unknown, LearnerProps>(
  ({ color = "currentColor", size = 24, ...rest }, ref) => (
    <svg
      // @ts-ignore
      ref={ref}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="2.75"
        y="2.75"
        width="18.5"
        height="18.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M11.2 7H8v10h8v-3.333h-4.8V7z" fill={color} />
    </svg>
  ),
);

export default Learner;
